exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".feedbackControls{padding-bottom:15px}.feedbackControls .commentBox{font-size:.8em}.feedbackControls .braveCheckbox{margin-top:20px;font-size:.8em}.feedbackControls .textLabel{margin-left:35px}.feedbackControls .needsCommentsMessage,.feedbackControls .revisedAtText{font-size:.8em;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/controls/feedback_controls.scss
// module id = 1479
// module chunks = 0